import React from "react";
import StatusBadge from "./StatusBadge";

const DataTable = ({ columns, data, loading, emptyMessage, onRowAction }) => {
  if (loading) {
    return (
      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, i) => (
              <tr key={i}>
                {columns.map((col) => (
                  <td key={col.key}>
                    <div className="skeleton h-4 w-full"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-12 text-gray-600">
        {emptyMessage || "No data found"}
      </div>
    );
  }

  return (
    <div>
      {/* Desktop table */}
      <div className="overflow-x-auto hidden md:block">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={row._id || idx}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render
                      ? col.render(row[col.key], row)
                      : col.key === "status"
                      ? <StatusBadge status={row[col.key]} />
                      : row[col.key] || "N/A"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="md:hidden space-y-2">
        {data.map((row, idx) => (
          <div key={row._id || idx} className="card bg-base-200 shadow-sm">
            <div className="card-body p-4">
              {columns.map((col) => (
                <div key={col.key} className="flex justify-between text-sm">
                  <span className="font-medium">{col.label}:</span>
                  <span>
                    {col.render
                      ? col.render(row[col.key], row)
                      : col.key === "status"
                      ? <StatusBadge status={row[col.key]} />
                      : row[col.key] || "N/A"}
                  </span>
                </div>
              ))}
              {onRowAction && (
                <div className="card-actions justify-end mt-2">
                  {onRowAction(row)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataTable;
